<div class="home__inner">
    @if (cmsGroups().length) {
        <cms-sections [groups]="cmsGroups()" />
    }
</div>
